/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
  Table, TableBody, TableCell, TableContainer, TableRow, Paper, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import CloseIcon from "@mui/icons-material/Close";
import "../styles/Digitalizaciones.css";
import "react-medium-image-zoom/dist/styles.css";
import { Buttons } from "../../../../general_components/Buttons";
import { FullFeaturedCrudGrid } from "./ListTableDigitalizaciones";
import { CajasContext } from "src/context/CajasContext/CajasContext";
import { SimpleDialogComponent } from "../../../../general_components/SimpleDialogComponent";
import { v4 as uuidv4 } from "uuid"; // Importar uuid para generar IDs únicos
import AlertDialog from "./AlertDialogDelete";
import { SnackbarMessenger } from "../../../../general_components/SnackbarMessenger";
import { getTiposContenidos } from "../../helpers/TipoContenidosData";
import esArray from "src/general_components/functionEsArray";
import { getTipoContenidosLocalizaciones } from "src/projects/gestion_comercial/cuentas/helpers/TipoContenidosData";
import { getMetadatosWhereIdTipoContenidos } from "../../helpers/MetadatoData";
import { postContenidos } from "../../helpers/ContenidosData";

// Estilos personalizados
const Title = styled(Typography)(({ theme }) => ({
  color: "#FFFFFF",
  fontWeight: "bold",
  fontSize: "1rem",
  marginBottom: theme.spacing(0),
}));

const CloseButton = styled(Button)(({ theme }) => ({
  color: "#FFFFFF",
}));

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0),
}));

// Componente principal
export const ContenidosDigitalizacionesList = ({
  modalState,
  setModalState,
  setActualizarListado,
  idCaja,
  cuentas_parametros,
  loteMaximo,
  id_sector
}) => {
  const {
    rows,
    setRows,
    setCheckedTotal,
    setClickCheckedTotal,
    checkedCaratula,
  } = useContext(CajasContext);

  // Estados locales
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [nroFolio, setNroFolio] = useState(loteMaximo || 0);
  const [saveImagesCaratula, setSaveImagesCaratula] = useState(false);
  const [updateImageSave, setUpdateImageSave] = useState({});
  const [primerRender, setPrimerRender] = useState(true);
  const [abrirPreguntaConsumoImagenes, setAbrirPreguntaConsumoImagenes] = useState(false);
  const [alertDelete, setAlertDelete] = useState(false);
  const [index, setIndex] = useState(false);
  const [deleteTrue, setDeleteTrue] = useState(false);
  const [tipoContenidoList, setTipoContenidoList] = useState([]);
  const [metadatosList, setMetadatosList] = useState([]);
  const [disabledTipoContenidoSelect, setDisabledTipoContenidoSelect] = useState(false);
  const [disabledMetadatoSelect, setDisabledMetadatoSelect] = useState(false);

  // Buscar id_tipo_contenidos_defecto
  const tipoContenidos = cuentas_parametros.find(item => item.alias === "id_tipo_contenidos_defecto");
  const idTipoContenidosDefecto = tipoContenidos ? tipoContenidos.valor : null;

  // Buscar id_metadatos_defecto
  const metadatos = cuentas_parametros.find(item => item.alias === "id_metadatos_defecto");
  const idMetadatosDefecto = metadatos ? metadatos.valor : null;

  // Estados para manejar selecciones
  const [selectedTipoContenido, setSelectedTipoContenido] = useState("");
  const [selectedMetadato, setSelectedMetadato] = useState("");

  const estilosTabla = {
    backgroundColor: "rgb(244, 246, 248)",
    color: "#637381",
    fontSize: 13,
    fontWeight: 'bold',
    borderRadius: 0,
    verticalAlign: 'inherit',
    border: '1px dashed rgb(241, 243, 244)',
  }

  //NOTE STATE PARA LAS ALERTAS
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const user_data = JSON.parse(localStorage.getItem("siam-user-data"));
  const id_perfil_usuario = user_data?.id_perfiles;

  // Función para cargar imágenes y convertirlas a Base64
  const uploadImages = async (event) => {
    const files = [...event.target.files].sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    const nuevosRegistros = []; // Array para almacenar los nuevos registros
    let folio = nroFolio;

    for (let file of files) {
      setLoading(true);
      const imageBase64 = await convertImageToBase64(URL.createObjectURL(file));

      // Obtener el nombre del archivo sin la extensión
      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "").replace(/\(.*?\)/g, '').trim();


      const nuevoRegistro = {
        model: "digitalizaciones",
        model_data: {
          id_tipo_contenidos: selectedTipoContenido, // Asignar id_tipo_contenidos
          id_contenidos: "",
          folio: folio,
          valor: "",
        },
        save: false,
        image: imageBase64,
        folio: folio,
        id: uuidv4(),
        descripcion: fileNameWithoutExtension, // Usar el nombre sin la extensión
        id_tipo_contenidos: selectedTipoContenido, // También aquí si es necesario
        checked: false,
      };

      nuevosRegistros.push(nuevoRegistro);
      folio = folio + 1;
    }

    setNroFolio(folio);
    setRows((prevRows) => [...prevRows, ...nuevosRegistros]); // Actualizar los registros existentes
    setLoading(false);
  };


  //NOTE FUNCION PARA PASAR LAS IMAGENES A BASE 64, PARA PODER ALMACENARLAS EN LA BASE DE DATOS
  const convertImageToBase64 = async (url, name) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data);
      }
    });
  }




  // const onClickSubmit = async () => {
  //   setLoading(true);

  //   try {
  //     const mappedArray = rows.map(item => ({
  //       id: "", // Mantiene el valor vacío según el ejemplo
  //       id_cajas: idCaja || "", // Valor de la caja seleccionada
  //       id_tipo_contenidos: selectedTipoContenido || "", // Valor del tipo de contenido seleccionado
  //       meta_datos: [{
  //         id: "", // Vacío según el ejemplo
  //         id_metadatos: selectedMetadato, // El ID de metadato
  //         valor: item.descripcion // Valor correspondiente del objeto inicial
  //       }],
  //       lote: item.folio || "", // Valor del lote seleccionado
  //       img: item.image || "" // Imagen en formato Base64
  //     }));

  //     // Dividir el array en lotes de 5
  //     const batchSize = 5;
  //     for (let i = 0; i < mappedArray.length; i += batchSize) {
  //       const batch = mappedArray.slice(i, i + batchSize); // Obtener lote de 5 elementos

  //       // Enviar el lote
  //       await postContenidosArray(batch);

  //       setSeverity("success");
  //       setMessage("Imágenes guardadas exitosamente."); // Mensaje de éxito
  //     }
  //   } catch (error) {
  //     setSeverity("error");
  //     setMessage(error.message || "Ocurrió un error al guardar las imágenes."); // Manejo de errores
  //   } finally {
  //     setSnackbarVisible(true); // Mostrar el mensaje en el snackbar
  //     setSaveImagesCaratula(!saveImagesCaratula); // Actualizar estado
  //     setLoading(false); // Desactivar el indicador de carga
  //   }
  // };


  // Guardar imágenes
  const onClickSubmit = async () => {
    setLoading(true);
    let allSuccessful = true; // Bandera para verificar si todas las pegadas fueron exitosas

    try {
      const mappedArray = rows.map(item => ({
        id: "", // Mantiene el valor vacío según el ejemplo
        id_cajas: idCaja || "", // Valor de la caja seleccionada
        id_tipo_contenidos: selectedTipoContenido || "", // Valor del tipo de contenido seleccionado
        meta_datos: [{
          id: "", // Vacío según el ejemplo
          id_metadatos: selectedMetadato, // El ID de metadato
          valor: item.descripcion // Valor correspondiente del objeto inicial
        }],
        lote: item.folio.toString() || "", // Valor del lote seleccionado
        img: item.image || "" // Imagen en formato Base64
      }));

      // Realizar la pegada por cada objeto en el array
      for (const contenido of mappedArray) {
        const response = await postContenidos(contenido);

        // Validar el status del response
        if (response.status === "false") {
          allSuccessful = false;
          console.error("Error en contenido:", contenido, response.message || "Error desconocido");
          setSeverity("error");
          setMessage(`Error al guardar una imagen: ${response.message || "Error desconocido"}`);
          break; // Opcional: detener el flujo si hay un error
        }
      }

      if (allSuccessful) {
        setSeverity("success");
        setMessage("Todas las imágenes fueron guardadas exitosamente."); // Mensaje de éxito
        setActualizarListado(true);
        handleClose();
      }
    } catch (error) {
      setSeverity("error");
      setMessage(error.message || "Ocurrió un error al guardar las imágenes."); // Manejo de errores
    } finally {
      setSnackbarVisible(true); // Mostrar el mensaje en el snackbar
      setSaveImagesCaratula(!saveImagesCaratula); // Actualizar estado
      setLoading(false); // Desactivar el indicador de carga
    }
  };





  const obtenerTipoContenido = async () => {
    let tipoContenidos = [];
    let responseStorage = JSON.parse(localStorage.getItem("siam-tipo_contenidos"));
    if (responseStorage === null) {
      tipoContenidos = await getTiposContenidos(true);
    } else {
      let tipoContenidosStorage = esArray(responseStorage.tipo_contenidos);
      if (responseStorage !== null) {
        tipoContenidos = tipoContenidosStorage;
      }
    }
    // TODO: Se hace el filtro por tipo contenidos cuentas localizaciones
    // Tipo Contenidos cuentas localizaciones
    let data = await getTipoContenidosLocalizaciones();

    const cuentas_localizaciones_tipo_contenidos = esArray(data).filter(objeto => objeto.id_cuentas_localizaciones === id_sector);
    const tipoContenidosFiltradoCuentaLocalizacion = tipoContenidos.filter((tipoContenido) =>
      cuentas_localizaciones_tipo_contenidos?.some((obj) => obj.id_tipo_contenidos === tipoContenido.id));

    tipoContenidos = tipoContenidosFiltradoCuentaLocalizacion.filter(objeto => objeto.digitalizado === "1");
    if (tipoContenidoList.length === 0) {
      const listRowsTipoContenidos = tipoContenidos.map((tipo_contenido) => {
        tipo_contenido.value = tipo_contenido.id;
        tipo_contenido.label = tipo_contenido.detalle;
        return tipo_contenido;
      });
      setTipoContenidoList(listRowsTipoContenidos);
    }
  };

  // Función para cerrar modales
  const handleClose = () => {
    setModalState(false);
    setCheckedTotal(false);
    setAbrirPreguntaConsumoImagenes(false);
    setClickCheckedTotal(false);
  };


  const obtenerDatos = async () => {
    await obtenerTipoContenido();
  };
  // **Eliminar fila**
  useEffect(() => {
    if (deleteTrue && index !== null) {
      try {
        // Intentar eliminar la fila por índice
        setRows((prevRows) => {
          if (index < 0 || index >= prevRows.length) {
            throw new Error("Índice inválido, no se puede eliminar el registro.");
          }
          return prevRows.filter((_, i) => i !== index);
        });
        // Restablecer estados y mostrar éxito
        setDeleteTrue(false);
        setIndex(null);
        setAlertDelete(false);
        setSeverity("success");
        setMessage("Registro eliminado con éxito!");
      } catch (error) {
        // Manejar errores y mostrar mensaje de error
        setSeverity("error");
        setMessage(error.message || "Ocurrió un error al eliminar el registro.");
      } finally {
        setSnackbarVisible(true);
      }
    }
  }, [deleteTrue, index]);

  useEffect(() => {
    if (rows.length > 0 && primerRender) {
      const cantRowChecked = rows.filter((item) => item.checked).length;
      setCheckedTotal(rows.length === cantRowChecked && checkedCaratula);
      setPrimerRender(false);
    }
    obtenerDatos();
  }, [rows]);
  useEffect(() => {
      // Buscar id_metadatos_defecto
    const folio_parametros_cuenta = cuentas_parametros.find(item => item.alias === "FOLIO_INIT_NUMBER");
    const valor_folio_parametros_cuenta = folio_parametros_cuenta ? folio_parametros_cuenta.valor : nroFolio;
    console.log("valor_folio_parametros_cuenta", valor_folio_parametros_cuenta);
    if(folio_parametros_cuenta){
      setNroFolio(valor_folio_parametros_cuenta);
    }
    obtenerDatos();
  }, []);

  // Selección automática si hay un único valor
  useEffect(() => {

    if (
      tipoContenidoList.length > 0 &&
      idTipoContenidosDefecto &&
      tipoContenidoList.some(item => item.value === idTipoContenidosDefecto)
    ) {
      // Solo establecer si idTipoContenidosDefecto existe en la lista
      setSelectedTipoContenido(idTipoContenidosDefecto);
      setDisabledTipoContenidoSelect(true);
      return;
    }
    if (tipoContenidoList.length === 1) {
      // Si hay un único valor en la lista, lo seleccionamos automáticamente
      setSelectedTipoContenido(tipoContenidoList[0].value);
    } 
  }, [tipoContenidoList, idTipoContenidosDefecto]);

  const handleTipoContenidoChange = (event) => {
    setSelectedTipoContenido(event.target.value);
  };

  const handleMetadatoChange = (event) => {
    setSelectedMetadato(event.target.value);
  };



  // En base al tipo de contenido seleccionado , se obtienen los metadatos de ese tipo de contenido
  useEffect(() => {
    const getMetadatosWhereIdTC = async () => {
      const meta_datos = await getMetadatosWhereIdTipoContenidos(
        selectedTipoContenido
      );

      const labelGrillaSet = new Set();
      const resultadoSinDuplicados = meta_datos.filter((metadato) => {
        const { label_form } = metadato;

        if (!labelGrillaSet.has(label_form)) {
          labelGrillaSet.add(label_form);
          return true;
        }
        return false;
      });

      setMetadatosList(resultadoSinDuplicados);
    }

    selectedTipoContenido && getMetadatosWhereIdTC();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTipoContenido]);


  useEffect(() => {
    if (
      metadatosList.length > 0 &&
      idMetadatosDefecto &&
      metadatosList.some(item => item.id === idMetadatosDefecto)
    ) {
      setSelectedMetadato(idMetadatosDefecto);
      setDisabledMetadatoSelect(true);
    }
  }, [metadatosList, idMetadatosDefecto]);



  return (
    <>
      {alertDelete && (
        <AlertDialog
          alertDelete={alertDelete}
          setDeleteTrue={setDeleteTrue}
          setAlertDelete={setAlertDelete}
        />
      )}
      <Dialog fullWidth maxWidth="xl" open={modalState} fullScreen>
        <DialogTitle>
          <Header>
            <Title>Listado Digitalizaciones</Title>
            <CloseButton onClick={handleClose}>
              <CloseIcon />
            </CloseButton>
          </Header>
        </DialogTitle>
        <DialogContent>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Grid container spacing={1} alignItems="center">
              {/* Tabla con dos filas */}
              <Grid item xs={6}>
                <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                  <Table size="small" aria-label="tabla de metadatos">
                    <TableBody>
                      {/* Selector de Tipo de Contenido */}
                      <TableRow>
                        <TableCell sx={estilosTabla}>Tipo Contenido</TableCell>
                        <TableCell sx={{ fontSize: 12 }}>
                          <FormControl fullWidth>
                            <InputLabel id="tipoContenidoSelect">Seleccionar</InputLabel>
                            <Select
                              value={selectedTipoContenido}
                              onChange={handleTipoContenidoChange}
                              displayEmpty
                              labelId="tipoContenidoSelect"
                              label="Tipo Contenido"
                              disabled={disabledTipoContenidoSelect}
                            >
                              {tipoContenidoList.map((tipo) => (
                                <MenuItem key={tipo.value} value={tipo.value}>
                                  {tipo.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>

                      {/* Selector de Metadatos */}
                      <TableRow>
                        <TableCell sx={estilosTabla}>Metadato</TableCell>
                        <TableCell sx={{ fontSize: 12 }}>
                          <FormControl fullWidth>
                            <InputLabel id="metadatoSelect">Seleccionar</InputLabel>
                            <Select
                              value={selectedMetadato}
                              onChange={handleMetadatoChange}
                              displayEmpty
                              labelId="metadatoSelect"
                              label="Metadatos    "
                              disabled={disabledMetadatoSelect}
                            >
                              {metadatosList.map((metadato) => (
                                <MenuItem key={metadato.id} value={metadato.id}>
                                  {metadato.label_form}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              {/* Botón Elegir Digitalizaciones */}
              <Grid item xs={6} style={{ textAlign: "center" }}>
                <Button
                  hidden={id_perfil_usuario === "9"}
                  variant="contained"
                  component="label"
                  endIcon={<PhotoCamera />}
                >
                  Elegir Digitalizaciones
                  <input
                    hidden
                    accept="image/*"
                    multiple
                    type="file"
                    onChange={uploadImages}
                  />
                </Button>
              </Grid>
            </Grid>
          </Stack>
          <Grid>
            <FullFeaturedCrudGrid
              tipoContenidoList={tipoContenidoList}
              updateImageSave={updateImageSave}
              setUpdateImageSave={setUpdateImageSave}
              setNroFolio={setNroFolio}
              nroFolio={nroFolio}
              setAlertDelete={setAlertDelete}
              setIndex={setIndex}
              disabledTipoContenidoSelect={true}
              nameFolioLote={"Lote"}
              disableCheckbox={true}
            />
          </Grid>
          <SnackbarMessenger
            open={snackbarVisible}
            message={message}
            severity={severity}
            close={() => {
              setSnackbarVisible(false);
            }}
          />
        </DialogContent>
        <Grid sx={{ margin: 5 }}>
          <Buttons
            disableButton={rows.length > 0? false : true}
            onClickSubmit={onClickSubmit}
            buttonCerrar={handleClose}

            hiddenButtons={id_perfil_usuario === "9"}
          />
        </Grid>
      </Dialog>

      {abrirPreguntaConsumoImagenes && (
        <SimpleDialogComponent />
      )}
    </>
  );
};
